import type { FacilityWorkflowRunPayload } from '@Application/WorkflowRuns/FacilityWorkflowRuns/Actions/facilityWorkflowRunsFetched';

/** The server answers with the supervision row, so the list refreshes without a second round-trip. */
export type WorkflowRunUnhandledAction = {
	type: 'WORKFLOW_RUN_UNHANDLED';
	payload: FacilityWorkflowRunPayload;
	facilityId: number;
	subjectId: number;
};

export default (
	payload: FacilityWorkflowRunPayload,
	facilityId: number,
	subjectId: number,
): WorkflowRunUnhandledAction => ({
	type: 'WORKFLOW_RUN_UNHANDLED',
	payload,
	facilityId,
	subjectId,
});
